document.addEventListener("DOMContentLoaded", function () {
  var productMeta = document.querySelector('body');
  
  function addClassOnScroll() {
    if (window.innerWidth <= 768) { // Assuming mobile breakpoint is 768px or lower
      if (window.scrollY > 100) {
        productMeta.classList.add('sticky-atc'); // Add your new class name here
      } else {
        productMeta.classList.remove('sticky-atc'); // Remove the class if not scrolled past 500px
      }
    } else {
      productMeta.classList.remove('sticky-atc'); // Remove the class on larger screens
    }
  }

  // Attach the scroll event listener
  window.addEventListener('scroll', addClassOnScroll);
});
